<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: student.full_name,
                        href: meta.links.student.show,
                    },
                    {
                        name: $tc('messages.links', 2),
                        href: meta.links.index,
                    },
                ]"
            />
        </template>

        <form action="" @submit.prevent="submit">
            <LinkBatchCreate v-model="form.links" :links-input="[]" />

            <div class="flex justify-end">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import LinkBatchCreate from '@/components/pageSpecific/LinkBatchCreate.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        LinkBatchCreate,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'student', 'links', 'fouls', 'familyInterviews'],
    data() {
        return {
            form: this.$inertia.form({
                links: this.links,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
